<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="150px"
        :model="dataForm"
        :disabled="isdisableds"
        :rules="editFormRules"
      >
        <el-form-item label="会员编号：" prop="BusinessId">
          <el-input
            v-model="dataForm.BusinessId"
            clearable
            placeholder="请输入会员编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="UserName">
          <el-input
            v-model="dataForm.UserName"
            clearable
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="Sex">
          <el-radio-group v-model="dataForm.Sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="民族：" prop="National">
          <el-input
            v-model="dataForm.National"
            clearable
            placeholder="请输入民族"
          ></el-input>
        </el-form-item>
        <el-form-item label="出生日期：" prop="Birthday">
          <el-date-picker
            v-model="dataForm.Birthday"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="手机号码：" prop="MobileNo">
          <el-input
            v-model="dataForm.MobileNo"
            clearable
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" prop="Email">
          <el-input
            v-model="dataForm.Email"
            clearable
            placeholder="请输入电子邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号码：" prop="IdentityCard">
          <el-input
            v-model="dataForm.IdentityCard"
            clearable
            placeholder="请输入身份证号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作单位：" prop="WorkUnit">
          <el-input
            v-model="dataForm.WorkUnit"
            clearable
            placeholder="请输入工作单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="职业：" prop="Occupation">
          <el-input
            v-model="dataForm.Occupation"
            clearable
            placeholder="请输入职业"
          ></el-input>
        </el-form-item>
        <el-form-item label="通讯地址：" prop="Address">
          <el-input
            v-model="dataForm.Address"
            clearable
            placeholder="请输入通讯地址位"
          ></el-input>
        </el-form-item>
        <el-form-item label="文化程度：" prop="Education">
          <el-select v-model="dataForm.Education" placeholder="请选择">
            <el-option
              v-for="item in educationOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌：" prop="Political">
          <el-select v-model="dataForm.Political" placeholder="请选择">
            <el-option
              v-for="item in politicalOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否在校学生：" prop="IsSchool">
          <el-radio-group v-model="dataForm.IsSchool">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="身份证：" prop="FrontImage">
          <el-row>
            <el-col :span="8">
              <of-upload
                class="upload-demo"
                list-type="picture-card"
                @onPreview="onPreview"
                @onRemove="onRemoveFrontImage"
                @onUpLoad="onUpLoadFrontImage"
                :limit="1"
                :fileList="FrontImage"
                :class="{ hide: hideFrontImage }"
                accept="image/jpeg, image/gif, image/png, image/jpg"
              >
                <div slot="content" class="idcardimg_contain">
                  <i slot="default" class="el-icon-camera-solid"></i>
                  <p class="idcardimg" v-if="!hideFrontImage">身份证正面</p>
                </div>
              </of-upload>
            </el-col>
            <el-col :span="16">
              <of-upload
                class="upload-demo"
                list-type="picture-card"
                @onPreview="onPreview"
                @onRemove="onRemoveBackImage"
                @onUpLoad="onUpLoadBackImage"
                :limit="1"
                :fileList="BackImage"
                :class="{ hide: hideBackImage }"
                accept="image/jpeg, image/gif, image/png, image/jpg"
              >
                <div slot="content" class="idcardimg_contain">
                  <i slot="default" class="el-icon-camera-solid"></i>
                  <p class="idcardimg" v-if="!hideBackImage">身份证反面</p>
                </div>
              </of-upload>
            </el-col>
          </el-row>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item label="个人证件照：" prop="File">
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            @onRemove="onRemove"
            @onUpLoad="onUpLoad"
            :limit="1"
            :fileList="fileList"
            :class="{ hide: hideUploadEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content" class="idcardimg_contain">
              <i slot="default" class="el-icon-camera-solid"></i>
            </div>
          </of-upload>
        </el-form-item>
        <el-form-item label="附件：" prop="ApplyFile">
          <of-upload
            class="upload-demo"
            list-type="fileList"
            @onRemove="onRemove2"
            @onUpLoad="onUpLoad2"
            @onExceed="onExceed"
            @onPreview="onPreviewdown"
            :limit="limitNum"
            :fileList="fileList2"
            :class="{ hide: hideUploadEdit2 }"
          >
            <div slot="content">
              <el-button>上传文件</el-button>
            </div>
          </of-upload>
        </el-form-item>
        <el-form-item label="会员级别：" prop="Level">
          <el-select v-model="dataForm.Level" placeholder="请选择">
            <el-option
              v-for="item in levelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员截止时间：" prop="ExpirationDate">
          <el-date-picker
            v-model="dataForm.ExpirationDate"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="入会时间：" prop="ApplyTime">
          <el-date-picker
            v-model="dataForm.ApplyTime"
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      if (!/^1[0-9]{10}$/.test(value)) {
        return callback(new Error("无效手机号码"));
      }
      callback();
    };
    //验证电子邮箱
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电子邮箱"));
      }
      if (
        !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
          value
        )
      ) {
        return callback(new Error("无效电子邮箱"));
      }
      callback();
    };
    //验证身份证号码
    var checkIdentityCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证号码"));
      }
      if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        return callback(new Error("无效身份证号码"));
      }
      callback();
    };
    return {
      editFormRules: {
        // BusinessId: {
        //   required: true,
        //   message: "请输入会员编号",
        //   trigger: "blur",
        // },
        UserName: {
          required: true,
          message: "请输入姓名",
          trigger: "blur",
        },
        Sex: {
          required: true,
          message: "请选择性别",
          trigger: "blur",
        },
        MobileNo: {
          required: true,
          validator: checkMobileNo,
          trigger: "blur",
        },
        Email: {
          required: true,
          validator: checkEmail,
          trigger: "blur",
        },
        IdentityCard: {
          required: true,
          validator: checkIdentityCard,
          trigger: "blur",
        },
        WorkUnit: {
          required: true,
          message: "请输入工作单位",
          trigger: "blur",
        },
        Address: {
          required: true,
          message: "请输入通讯地址",
          trigger: "blur",
        },
        Education: {
          required: true,
          message: "请选择文化程度",
          trigger: "blur",
        },
        Level: {
          required: true,
          message: "请选择会员等级",
          trigger: "blur",
        },
        ApplyTime: {
          required: true,
          message: "请选择入会时间",
          trigger: "blur",
        },
        Occupation: {
          required: true,
          message: "请输入职业",
          trigger: "blur",
        },
        IsSchool: {
          required: true,
          message: "请选择是否为在校学生",
          trigger: "blur",
        },
      },
      isConfirm: false,
      isdisableds: false,
      ishide: false,
      activeValue: 1,
      inactiveValue: 0,
      hideUploadEdit: false,
      //文化程度枚举
      educationOptions: [
        { value: 0, label: "小学" },
        { value: 1, label: "初中" },
        { value: 2, label: "高中/职高" },
        { value: 3, label: "专科" },
        { value: 4, label: "本科" },
        { value: 5, label: "研究生" },
        { value: 6, label: "博士" },
        { value: 7, label: "其他" },
      ],
      politicalOptions: [
        { label: "中共党员", value: 0 },
        { label: "共青团员", value: 1 },
        { label: "民主党派", value: 2 },
        { label: "无党派人士", value: 3 },
        { label: "群众", value: 4 },
      ],
      //会员等级
      levelOptions: [
        { value: 0, label: "普通会员" },
        { value: 1, label: "特殊会员" },
        { value: 2, label: "永久会员" },
      ],

      isEdit: false,
      fileList: [],
      limitNum: 1,
      width: "50%",
      dialogVisible: false,
      dialogImageUrl: "",
      FrontImage: [],
      BackImage: [],
      hideFrontImage: false,
      hideBackImage: false,
      fileList2: [],
      hideUploadEdit2: false,
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.getFile();
    this.getFrontImage();
    this.getBackImage();
    this.getapplyFile();
    if (this.dataForm.Id) {
      this.dataForm.ExpirationDate = this.dataForm.ExpirationDate * 1000;
    }
  },
  components: {
    OfDialog,
    OfUpload,
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //新增
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.Status = 0;
          params.ApplyStatus = 0;
          params.UserId = this.GetCurrentUserInfo.Id;
          params.ApplyTime = params.ApplyTime / 1000;
          params.Birthday = params.Birthday / 1000;
          params.ExpirationDate = params.ExpirationDate / 1000;
          api
            .SavePersonalMember(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //删除附件
    onRemove() {
      this.fileList = [];
      this.dataForm.File = null;
      this.hideUploadEdit = false;
    },
    //删除附件
    onRemove2() {
      this.fileList2 = [];
      this.dataForm.ApplyFile = null;
      this.hideUploadEdit2 = false;
    },
    //上传附件
    onUpLoad(file) {
      if (file.response.Code === 0) {
        this.dataForm.File = "/files" + file.response.Data.StorePath;
        this.hideUploadEdit = true;
        this.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //上传附件
    onUpLoad2(file) {
      if (file.response.Code === 0) {
        const list = { name: file.name, url: file.response.Data.FileId };
        this.fileList2.push(list);
        this.dataForm.ApplyFile = JSON.stringify(this.fileList2);
        if (this.fileList2.length >= this.limitNum) {
          this.hideUploadEdit2 = true;
        }
        this.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    onExceed() {
      this.$message({
        message: `只能选择 ${this.limitNum} 个文件`,
        type: "error",
      });
    },
    //点击查看
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onPreviewdown(file) {
      saveAs(file.url, file.name);
    },
    //初始化附件
    getFile() {
      let vm = this;
      if (
        vm.dataForm.File === undefined ||
        vm.dataForm.File === null ||
        vm.dataForm.File == ""
      ) {
        vm.fileList = []
        return;
      }
      vm.hideUploadEdit = true;
      vm.fileList = [{ url: vm.dataForm.File }];
    },
    getapplyFile() {
      if (
        this.dataForm.ApplyFile === undefined ||
        this.dataForm.ApplyFile === null ||
        this.dataForm.ApplyFile == ""
      ) {
        return;
      }
      this.fileList2 = JSON.parse(this.dataForm.ApplyFile);
      if (this.fileList2.length >= this.limitNum) {
        this.hideUploadEdit2 = true;
      }
    },
    //上传身份证正面图
    onUpLoadFrontImage(file) {
      if (file.response.Code === 0) {
        this.dataForm.FrontImage = '/files' + file.response.Data.StorePath;
        this.$message({
          message: "身份证正面图片上传成功",
          type: "success",
        });
        this.hideFrontImage = true;
      }
    },
    //上传身份证反面图
    onUpLoadBackImage(file) {
      if (file.response.Code === 0) {
        this.dataForm.BackImage = '/files' + file.response.Data.StorePath;
        this.$message({
          message: "身份证正面图片上传成功",
          type: "success",
        });
        this.hideBackImage = true;
      }
    },
    //删除身份证正面图
    onRemoveFrontImage() {
      this.FrontImage = [];
      this.dataForm.FrontImage = null;
      this.hideFrontImage = false;
    },
    //删除身份证反面图
    onRemoveBackImage() {
      this.BackImage = [];
      this.dataForm.BackImage = null;
      this.hideBackImage = false;
    },
    //加载身份证正面图
    getFrontImage() {
      if (
        this.dataForm.FrontImage === undefined ||
        this.dataForm.FrontImage === null ||
        this.dataForm.FrontImage == ""
      ) {
        return;
      }
      this.hideFrontImage = true;
      this.FrontImage = [{ url: this.dataForm.FrontImage }];
    },
    //加载身份证反面图
    getBackImage() {
      if (
        this.dataForm.BackImage === undefined ||
        this.dataForm.BackImage === null ||
        this.dataForm.BackImage == ""
      ) {
        return;
      }
      this.hideBackImage = true;
      this.BackImage = [{ url: this.dataForm.BackImage }];
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
</style>

<style>
.hide .el-upload--fileList {
  display: none;
}
.idcardimg_contain {
  position: relative;
}
.idcardimg {
  position: absolute;
  z-index: 5;
  top: 30%;
  left: 25%;
}
</style>
